import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import CurrentAffairsDaily from "./current-affairs-daily/CurrentAffairsDaily";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const CurrentAffairsIndex = () => {
    return (
        <>
        
 
        <CurrentAffairsDaily />
        {/* <CurrentAffairsCategorized /> */}
        {/* <CurrentAffairsQuiz /> */}
        {/* <CurrentAffairsMonthly /> */}
        {/* <CurrentAffairsPushNotification /> */}
        
        
        </>
    );
};

export default CurrentAffairsIndex;